// extracted by mini-css-extract-plugin
export default {"landscapeBasicInformationEditTemplateWrapper":"LandscapeBasicInformationEditPage_landscapeBasicInformationEditTemplateWrapper__RvL+8"};